import React, { useEffect, useState } from "react";
import { Flex } from "./Flex";
import Icon, { type MdIconName } from "./Icon";
import "./ChevronRoundButton.css";

type Direction = "up-or-down" | "left-or-right";
type ChevronRoundButtonUiState = "expanded" | "collapsed";

type ChevronRoundButtonProps = {
    onToggleClick: (open: boolean) => void;
    direction: Direction | null | undefined;
    /**
     * Property to enforce and manage collapse state of chevron
     */
    state?: ChevronRoundButtonUiState | null | undefined;
};

function ChevronRoundButton(props: ChevronRoundButtonProps) {
    const { state: stateProp, direction, onToggleClick } = props;
    const [state, setState] = useState<ChevronRoundButtonUiState>("collapsed");
    const iconMap: Record<ChevronRoundButtonUiState, MdIconName> =
        direction === "left-or-right"
            ? {
                  collapsed: "ChevronLeft",
                  expanded: "ChevronRight",
              }
            : {
                  collapsed: "ExpandMore",
                  expanded: "ExpandLess",
              };
    const CollapedIcon = Icon[iconMap.collapsed];
    const ExpandedIcon = Icon[iconMap.expanded];

    useEffect(() => {
        if (stateProp) {
            setState(stateProp);
        }
    }, [stateProp]);

    return (
        <Flex.Column
            className="component-round-button"
            onClick={() => {
                const value = state === "collapsed" ? "expanded" : "collapsed";
                setState(value);
                onToggleClick(value === "expanded");
            }}
        >
            {state === "collapsed" ? <CollapedIcon.Medium /> : <ExpandedIcon.Medium />}
        </Flex.Column>
    );
}

export default ChevronRoundButton;
